import { DivConst } from 'constants/divConst';
import { getContentsTypeStrJpn } from 'utils/content';

import type { JSX } from 'react';

/**
 * コンテンツ形式表示コンポーネント
 */
export default function ContentTypeBadge(props: {
  contentsTypeDiv: number | null;
  size?: 'normal' | 'large';
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  const getClassColor = (): string => {
    switch (props.contentsTypeDiv) {
      case DivConst.items.contentsType.quiz.value:
        return 'content-type-quiz';
      case DivConst.items.contentsType.diagnosis.value:
        return 'content-type-diagnosis';
      case DivConst.items.contentsType.form.value:
        return 'content-type-form';
      case DivConst.items.contentsType.voiceChat.value:
        return 'content-type-voice-chat';
      default:
        return '';
    }
  };

  const getClassSize = (): string => {
    if (props.size === 'large') {
      return 'badge-common-lg ';
    }
    return '';
  };

  const getName = (): string => {
    return getContentsTypeStrJpn(props.contentsTypeDiv);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <span className={`badge badge-common ${getClassSize()} ${getClassColor()}`}>{getName()}</span>
    </>
  );
}
